import {FC} from 'react';
import { useForm } from 'react-hook-form';
// custom
import { IPersonalInfo } from '../../../../common/state/subscriptions/personal_info';

export type PersonalInfoFormData = IPersonalInfo;

type PersonalInfoFormProps = {
    defaultFormData: IPersonalInfo,
    onSubmit: (data: IPersonalInfo) => void
};

const PersonalInfoForm: FC<PersonalInfoFormProps> = ({defaultFormData, onSubmit}) => {
    const { register, handleSubmit, setValue } = useForm<PersonalInfoFormData>({defaultValues: defaultFormData});

    //evt handlers
    const onFormSubmit = (formData: PersonalInfoFormData) => {
        // console.log('Form data is: ', formData);
        onSubmit(formData);
    };

    return <section id="form-section"
        className="w-full p-4 my-3 mr-3 bg-white shadow-lg lg:w-3/4 rounded-xl dark:bg-gray-900">
        <h1 className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400">
            1. Personal Information
        </h1>
        <p className="p-4 my-4 text-gray-700 dark:text-gray-300 dartext-base">
            Please fill in the information of the person who is <strong>attending the event, as per their passport document.</strong>
        </p>
        <form onSubmit={handleSubmit(onFormSubmit)} className="grid w-full grid-cols-1 gap-4 mb-6 lg:grid-cols-2">
            {/* col 1:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    First Name*
                </label>
                <input {...register('first_name')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-first-name" type="text" placeholder="John" />
            </div>
            {/* col 1:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Last Name*
                </label>
                <input {...register('last_name')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-last-name" type="text" placeholder="Doe" />
            </div>
            {/* col 2:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Passport ID*
                </label>
                <input {...register('passport')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-passport" type="text" placeholder="P123456" />
            </div>
            {/* col 2:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Email Address*
                </label>
                <input {...register('email')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-email" type="text" placeholder="john.doe@gmail.com" />
            </div>
            {/* col 3:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Contact Number*
                </label>
                <input {...register('contact')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-contact" type="text" placeholder="+1 123 45678" />
            </div>
            {/* col 3:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Address*
                </label>
                <input {...register('address')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-address" type="text" placeholder="River Drive, Jersey City" />
            </div>
            {/* col 4:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    City*
                </label>
                <input {...register('city')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-city" type="text" placeholder="New Jersey" />
            </div>
            {/* col 4:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Country*
                </label>
                <input {...register('country')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-country" type="text" placeholder="USA" />
            </div>
            {/* col 5:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    ZipCode*
                </label>
                <input {...register('pin_code')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-zipcode" type="text" placeholder="4075" />
            </div>
            {/* col 5:2 */}
            <div className="w-full px-3">
                <button type='submit'
                    className="px-4 py-2 mx-3 my-6 font-bold text-white bg-blue-500 border-b-4 border-blue-700 rounded hover:bg-blue-400 hover:border-blue-500">
                    Proceed
                </button>
                <button type='reset'
                    className="px-4 py-2 mx-3 my-6 font-bold text-gray-700 bg-gray-300 border-b-4 border-gray-500 rounded hover:bg-gray-400 hover:text-white hover:border-gray-700">
                    Reset
                </button>
            </div>
        </form>
    </section>;
};

export default PersonalInfoForm;